import React from 'react';
import PropTypes from 'prop-types';
import PaymentMethods from '../../../../../commonComponents/modal/components/PaymentMethods';
import StripeCardProp from '../../../../profile/propTypes/StripeCardProp';

const PaymentStep = ({
  tenant,
  userCreditCards,
  handleIsLoading,
  selectedCreditCard,
  tabActive,
  updatePaymentMethod,
  showSaveCard,
  hidePaypal,
}) => (
  <PaymentMethods
    cards={userCreditCards}
    vatTypes={[]}
    isSubscription
    tenant={tenant}
    tabActive={tabActive}
    updatePaymentMethod={updatePaymentMethod}
    selectedCreditCard={selectedCreditCard}
    handleIsLoading={handleIsLoading}
    showSaveCard={showSaveCard}
    hidePaypal={hidePaypal}
  />
);

PaymentStep.propTypes = {
  tenant: PropTypes.shape({
    settings: PropTypes.shape({
      paymentMethods: PropTypes.shape([]).isRequired,
    }).isRequired,
  }).isRequired,
  handleIsLoading: PropTypes.func.isRequired,
  selectedCreditCard: PropTypes.func.isRequired,
  updatePaymentMethod: PropTypes.func.isRequired,
  tabActive: PropTypes.string.isRequired,
  userCreditCards: PropTypes.arrayOf(PropTypes.shape(StripeCardProp.propType))
    .isRequired,
  showSaveCard: PropTypes.bool.isRequired,
  hidePaypal: PropTypes.bool,
};

PaymentStep.defaultProps = {
  hidePaypal: false,
};

export default PaymentStep;
